import { getRequest } from "api/apiCaller";
import AutocompleteAntd from "components/autocomplete/AutocompleteAntd";
import API_URL from "constant/api-url";
import { useCallback, useEffect, useRef, useState } from "react";

const OPTIONS_SIZE = 15;

const AutocompleteUser = ({ ...otherProps }) => {
  const lastestRequest = useRef();
  const [listOption, setListOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValues, setSearchValues] = useState({
    text: "",
    order: "createdAt DESC",
    limit: OPTIONS_SIZE,
  });

  const convertSearchValuesToParam = useCallback(() => {
    let searchWhere;
    if (!searchValues.text) {
      searchWhere = null;
    } else {
      searchWhere = {
        username: { like: searchValues.text.trim() },
      };
    }

    return {
      order: searchValues.order,
      limit: searchValues.limit,
      ...(searchWhere && { where: searchWhere }),
    };
  }, [searchValues]);

  const getListOption = useCallback(async () => {
    setLoading(true);
    const filter = convertSearchValuesToParam(searchValues);
    const currentRequest = getRequest(API_URL.USER, {
      filter,
    });
    lastestRequest.current = currentRequest;
    currentRequest
      .then((res) => {
        if (lastestRequest.current === currentRequest) {
          setListOption(res.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        if (lastestRequest.current === currentRequest) {
          setLoading(false);
        }
        console.error(error);
      });
  }, [convertSearchValuesToParam, searchValues]);

  const handleChangeTextInput = (inputString) => {
    setSearchValues((prev) => ({
      ...prev,
      text: inputString,
    }));
  };

  const handleScrollToBottom = () => {
    setSearchValues((prev) => ({
      ...prev,
      limit: listOption.length + OPTIONS_SIZE,
    }));
  };

  useEffect(() => {
    getListOption();
  }, [getListOption]);

  return (
    <AutocompleteAntd
      label="Tài khoản"
      options={listOption.map((item) => ({
        value: item.id,
        label: `${item.username}`,
      }))}
      onInputChange={handleChangeTextInput}
      onScrollBottom={handleScrollToBottom}
      loading={loading}
      {...otherProps}
    />
  );
};

export default AutocompleteUser;
